export default class DtoInstallationPiezoMeasures {
    constructor(obj) {
        this.measureDate = obj.measureDate // Option[DateTime],
        this.value = obj.value // Option[Double],
        this.dataType = obj.dataType // Option[Int],
        this.group = obj.group // Option[String] // MIN/MAX/SUM
        this.unit = obj.unit // Option[String]
    }
}
